var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;

  return "    <thead>\n    <tr>\n        <th class=\"col-xs-3\"><span>"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.settings.license.purchase.history.purchasing.item",{"name":"i18n","hash":{},"data":data}))
    + "</span></th><th class=\"col-xs-3\"><span>"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.settings.license.purchase.history.purchasing.date",{"name":"i18n","hash":{},"data":data}))
    + "</span></th><th class=\"col-xs-3\"><span>"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.settings.license.purchase.history.purchasing.period",{"name":"i18n","hash":{},"data":data}))
    + "</span></th><th class=\"col-xs-3\"><span>"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.settings.license.purchase.history.purchasing.amount",{"name":"i18n","hash":{},"data":data}))
    + "</span></th>\n    </tr>\n    </thead>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "    <tr class=\"\" data-id=\"4\">\n        <td class=\"col-xs-3\"><span>"
    + alias2(alias1((depth0 != null ? depth0.description : depth0), depth0))
    + "</span></td><td class=\"col-xs-3\"><span>"
    + alias2(alias1((depth0 != null ? depth0.dateCreated : depth0), depth0))
    + "</span></td><td class=\"col-xs-3\"><span>"
    + alias2(alias1((depth0 != null ? depth0.startDate : depth0), depth0))
    + " "
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"pos.settings.license.purchase.purchasing.expiry.date.to",{"name":"i18n","hash":{},"data":data}))
    + " "
    + alias2(alias1((depth0 != null ? depth0.endDate : depth0), depth0))
    + " </span></td><td class=\"col-xs-3\"><span style=\"border-right: none;\">"
    + alias2(alias1((depth0 != null ? depth0.price : depth0), depth0))
    + "</span></td>\n    </tr>\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "    <tr class=\"\">\n        <td class=\"tableName\" colspan=\"4\" style=\"text-align: center;font-size: 15px;background-color: transparent;margin-left: 10px\">\n            "
    + container.escapeExpression(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"pos.licenses.empty",{"name":"i18n","hash":{},"data":data}))
    + "\n        </td>\n    </tr>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"col-xs-12\">\n<table class=\"table\" style=\"margin-top: 20px;\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.collection : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    <tbody>\n\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.collection : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.collection : depth0),{"name":"unless","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </tbody>\n</table>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/pos/settings/PurchaseHistoryList.handlebars
// module id = 619
// module chunks = 0